/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-28 13:59:38
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-16 11:32:49
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * getBillList
   * @description 合同列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getAdminBillList(data) {
    return request.post(`${BASE_URL}/admin_bill/list`, data)
  },
  /**
   * saveBill
   * @description 保存合同
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  saveAdminBillAudit(data) {
    return request.post(`${BASE_URL}/admin_bill/audit`, data)
  },
  saveAdminBillAuditBatch(data) {
    return request.post(`${BASE_URL}/admin_bill/batchAudit`, data)
  },
  /**
   * deleteBill
   * @description 删除合同
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteAdminBill(id) {
    let data = {id:id}
    return request.post(`${BASE_URL}/admin_bill/delete`, data)
  },
  // 任务审核列表接口
  posttask(data) {
    return request.post(`${BASE_URL}/mission/list`, data)
  },
 
  // 公域任务列表
  postDaily_taskList(data) {
    return request.post(`${BASE_URL}/daily_task/list`, data)
  },
  // 公域任务详情
  postDaily_taskView(data) {
    return request.post(`${BASE_URL}/daily_task/view`, data)
  },
 
  // 私域任务详情
  postMissionView(id,data) {
    return request.post(`${BASE_URL}/mission/view/${id}`, data)
  },
  // 审核公域任务
  postDaily_taskExamine(id,data) {
    return request.post(`${BASE_URL}/daily_task/examine/${id}`, data)
  },
  postStatus(id,data) {
    return request.post(`${BASE_URL}/mission/examine/${id}`, data)
  },

  feetbackUrl(data) {
    return request.get(`paihuo/feedback/list`, data)
},
  //增值税管理列表
  postAdded_taxList(data) {
    return request.post(`${BASE_URL}/added_tax/list`, data)
  },
  //打开/关闭收取增值税开关
  postAdded_taxUpdate(data) {
    return request.post(`${BASE_URL}/added_tax/update`, data)
  },
}